"use strict";

let isInitialized = false;
let initCallbacks = [];

export default {
  initTrustpilot() {
    if (isInitialized) return;

    var script_elem = document.createElement("script");
    script_elem.type = "text/javascript";
    script_elem.src = "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
    var head = document.getElementsByTagName("head")[0];
    head.appendChild(script_elem);
    isInitialized = true;

    for (let callback of initCallbacks) {
      callback();
    }
    initCallbacks = [];
  },
  onInit(callback) {
    if (isInitialized) {
      callback();
    }
    else {
      initCallbacks.push(callback);
    }
  }
}


// WEBPACK FOOTER //
// ./src/trustpilot.js